import isArray from 'lodash/isArray';

import Storage, { KEY_RECENT_DRIVE_DESTINATIONS } from '@/common/services/Storage';
import { RecentDestinationId } from '@/forwarding/types/RecentDestinationId';

class RecentDestinationStorage {
  static get(): RecentDestinationId[] {
    const value = Storage.getObject(KEY_RECENT_DRIVE_DESTINATIONS, Storage.STORAGE_LOCAL);

    return isArray(value) ? value : [];
  }

  static add(destination: RecentDestinationId) {
    const data = this.get().filter((d) => d !== destination);

    const storageLimit = 500;
    const newData = [destination, ...data].slice(0, storageLimit);

    Storage.saveObject(KEY_RECENT_DRIVE_DESTINATIONS, newData, Storage.STORAGE_LOCAL);
  }
}

export default RecentDestinationStorage;
